var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14287_59334",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14287_59334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5175C11.59 10.5175 11.25 10.1776 11.25 9.7675V6.4375C11.25 6.0275 11.59 5.6875 12 5.6875C12.41 5.6875 12.75 6.0275 12.75 6.4375V9.7675C12.75 10.1876 12.41 10.5175 12 10.5175Z",
    fill: "#1D1B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0208 20.3483C9.44084 20.3483 6.87084 19.9382 4.42084 19.1182C3.51084 18.8183 2.82084 18.1683 2.52084 17.3483C2.22084 16.5283 2.32084 15.5883 2.81084 14.7683L4.08084 12.6483C4.36084 12.1783 4.61084 11.2983 4.61084 10.7483V8.64828C4.61084 4.55828 7.93084 1.23828 12.0208 1.23828C16.1108 1.23828 19.4308 4.55828 19.4308 8.64828V10.7483C19.4308 11.2883 19.6808 12.1783 19.9608 12.6483L21.2308 14.7683C21.7008 15.5483 21.7808 16.4783 21.4708 17.3283C21.1608 18.1783 20.4808 18.8282 19.6208 19.1182C17.1708 19.9482 14.6008 20.3483 12.0208 20.3483ZM12.0208 2.74828C8.76084 2.74828 6.11084 5.39828 6.11084 8.65828V10.7583C6.11084 11.5683 5.79084 12.7383 5.37084 13.4283L4.10084 15.5583C3.84084 15.9883 3.78084 16.4483 3.93084 16.8483C4.08084 17.2483 4.42084 17.5483 4.90084 17.7083C9.50084 19.2383 14.5608 19.2383 19.1608 17.7083C19.5908 17.5683 19.9208 17.2483 20.0708 16.8283C20.2308 16.4083 20.1808 15.9483 19.9508 15.5583L18.6808 13.4383C18.2608 12.7483 17.9408 11.5783 17.9408 10.7683V8.66828C17.9308 5.39828 15.2808 2.74828 12.0208 2.74828Z",
    fill: "#1D1B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0019 22.8964C10.9319 22.8964 9.88187 22.4564 9.12187 21.6964C8.36187 20.9364 7.92188 19.8864 7.92188 18.8164H9.42188C9.42188 19.4964 9.70188 20.1564 10.1819 20.6364C10.6619 21.1164 11.3219 21.3964 12.0019 21.3964C13.4219 21.3964 14.5819 20.2364 14.5819 18.8164H16.0819C16.0819 21.0664 14.2519 22.8964 12.0019 22.8964Z",
    fill: "#1D1B20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7035b123995c92d54c7798677ceb28b3.svg";
export { ForwardRef as ReactComponent };